import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config/api';
import { FiExternalLink, FiDownload } from 'react-icons/fi';
import Button from './Button'; // Assuming Button component exists

/**
 * StaticFileProxy component
 *
 * This component handles requests to /static/* paths and redirects them to the backend
 * It's used to proxy static file requests from the frontend to the backend
 *
 * Improvements:
 * - Renders images directly within the app layout
 * - Opens other files in a new tab to prevent app reload
 */
const StaticFileProxy = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const fullPath = location.pathname;
  const [isRedirecting, setIsRedirecting] = useState(false);

  // Check if the file is an image
    const isImage = /\.(jpg|jpeg|png|gif|webp|svg|ico)$/i.test(fullPath);

    // Construct target URL
    const backendUrl = API_BASE_URL;
    const targetUrl = `${backendUrl}${fullPath}`;

    useEffect(() => {
        if (!isImage && !isRedirecting) {
            setIsRedirecting(true);
            // For non-images, open in new tab
            // Note: window.open inside useEffect might be blocked by some browsers (e.g., Safari).
            // The "Open File Again" button in the UI below serves as a fallback for these cases.
            window.open(targetUrl, '_blank');

            // Optional: Go back after a delay or just stay here with a message
            // navigate(-1); 
        }
    }, [fullPath, isImage, isRedirecting, targetUrl]);

  if (isImage) {
    return (
      <div style={{
        padding: '2rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh'
      }}>
        <img 
          src={targetUrl} 
          alt="Static Asset" 
          style={{ 
            maxWidth: '100%', 
            maxHeight: '80vh',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            borderRadius: '0.5rem'
          }} 
        />
        <div style={{ marginTop: '1rem' }}>
          <Button 
            as="a" 
            href={targetUrl} 
            target="_blank" 
            variant="outline"
            size="small"
          >
            <FiExternalLink /> فتح الصورة الأصلية
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      padding: '40px',
      textAlign: 'center',
      marginTop: '50px',
      fontFamily: 'inherit',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px'
    }}>
      <div style={{ fontSize: '3rem', color: '#6366f1' }}>
        <FiDownload />
      </div>
      <h2>جاري فتح الملف...</h2>
      <p style={{ color: '#64748b', maxWidth: '500px' }}>
        تم فتح الملف في نافذة جديدة. إذا لم يفتح، انقر على الزر أدناه.
      </p>
      
      <div style={{ display: 'flex', gap: '10px' }}>
        <Button 
          as="a" 
          href={targetUrl} 
          target="_blank"
          variant="primary"
        >
          <FiExternalLink /> فتح الملف مرة أخرى
        </Button>
        
        <Button 
          onClick={() => navigate(-1)}
          variant="secondary"
        >
          العودة للخلف
        </Button>
      </div>
    </div>
  );
};

export default StaticFileProxy;
